export default function () {
  return {
    companiesCount: 0,
    offersCount: 0,
    frontpageData: {},
  }
}
